import { patchMethodWithFormToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const UPDATE_LEAD_CAPTURE = 'UPDATE_LEAD_CAPTURE';
export const UPDATE_LEAD_CAPTURE_SUCCESS = 'UPDATE_LEAD_CAPTURE_SUCCESS';
export const UPDATE_LEAD_CAPTURE_FAILURE = 'UPDATE_LEAD_CAPTURE_FAILURE';

// Action Creators
export const updateLeadCapture = () => ({
  type: UPDATE_LEAD_CAPTURE,
});

export const updateLeadCaptureSuccess = (data) => ({
  type: UPDATE_LEAD_CAPTURE_SUCCESS,
  payload: data,
});

export const updateLeadCaptureFailure = (error) => ({
  type: UPDATE_LEAD_CAPTURE_FAILURE,
  payload: error,
});

// Thunk Function
export const updateLeadCaptureCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(updateLeadCapture());
    try {
      const response = await patchMethodWithFormToken(
        url.leadCapture + data?.id + '/',
        data?.detail
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(updateLeadCaptureSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(updateLeadCaptureFailure(response?.data));
      }
    } catch (error) {
      dispatch(updateLeadCaptureFailure(error?.message));
    }
  };
};
